
import Toast from 'vux/src/components/toast/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
components: {
Toast,
Confirm
},
data() {
return {
doctorid: this.$route.query.doctorid,
openid: this.$route.query.openid,
phone: this.$route.query.telePhone,
cashSum: '',
accountbalance: 0,//可提现金额
maximumCashWithdrawable: 0,//最多可提现金额
isSubmit: true,
isButton: '提现',
toastText: '',
showPositionValue: false,
isCheck: false
}
},

methods: {

check(){
if(this.isCheck){
this.isCheck = false;
}else{
this.isCheck = true;
}
},

getCash(){
this.$doRequest("/api/accountdetail/getDoctorCashWithdrawal?doctorid="+this.doctorid,null,res => {
this.accountbalance = res.accountbalance;
if(!res.displayCashButton){
this.isSubmit = false;
this.isButton = '财务结算中，停止提现';
}
if(this.accountbalance && this.accountbalance >= 0){
this.isSubmit = true;
}else{
this.isSubmit = false;
this.isButton = '余额不足';
}
this.maximumCashWithdrawable = res.maximumCashWithdrawable;
});
},
checkout(){
if(Number(this.cashSum) > this.accountbalance || Number(this.cashSum) > this.maximumCashWithdrawable){
this.toastText = '超出可提现金额';
this.showPositionValue = true;
this.isButton = '余额不足';
this.isSubmit = false;
}else if(Number(this.cashSum) < 1){
this.toastText = '提现金额不低于1元';
this.showPositionValue = true;
this.isSubmit = false;
}else{
this.isSubmit = true;
}
},

cashSubmit(){
if(this.cashSum){
this.cashSum = Number(this.cashSum);
}

if(this.cashSum == ''){
this.toastText = '请输入提现金额';
this.showPositionValue = true;
return;
}else if(this.cashSum < 0){
this.toastText = '请输入正确的金额';
this.showPositionValue = true;
return;
}else if(this.cashSum > this.maximumCashWithdrawable){
this.toastText = '超出可提现金额最大限制';
this.showPositionValue = true;
return;
}else if(this.cashSum > this.accountbalance){
this.isButton = '余额不足';
this.toastText = '超出可提现金额';
this.showPositionValue = true;
return;
}
if(this.isSubmit){
this.isSubmit = false;
let params = {
userid: this.doctorid,
phone: this.phone,
openid: this.openid,
money: this.cashSum
};
this.$doRequest('api/doctorwithdraw/redEnvelopeCashWithdrawal',params ,res => {
this.isCheck = true;
this.isSubmit = true;
this.cashSum = '';
this.getCash();
},err => {
this.isSubmit = true;
this.toastText = err.message;
this.showPositionValue = true;
});
}
}
},

created: function() {
this.getCash();
}
}



// WEBPACK FOOTER //
// ./src/views/cash/index.vue